import React, { Component } from 'react'
import YouTubePlayer from 'react-player/youtube'

import { video } from './styles'

class Video extends Component {
  render() {
    const { videoUrl } = this.props
    return (
      <section className="video">
        <YouTubePlayer
          className="react-player"
          url={videoUrl}
          width="100%"
          height="100%"
        />
        <style jsx>{video}</style>
      </section>
    )
  }
}
export default Video
